import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/pro-regular-svg-icons/faCheck';
import { faCheckDouble } from '@fortawesome/pro-regular-svg-icons/faCheckDouble';
import { format } from 'date-fns';

/**
 * @param {string} rawDate
 * @param {string} dateFormat
 * @returns {string}
 */
export const getFormatedDate = (rawDate: string, dateFormat = 'dd.MM.yyyy hh:mm'): string => {
    if (typeof rawDate !== 'string') return rawDate;

    try {
        const formattedDate = format(new Date(rawDate), dateFormat);

        return formattedDate;
    } catch {
        return rawDate;
    }
};

/**
 * Параметры lastFromSupport и isReaded являются числом 0/1 ,
 * но т.к. это не boolean корректнее сверять именно значения, никто не гарантирует,
 * что там не будет другого числа.
 * @param {number} isReaded
 * @param {number} lastFromSupport
 * @param {(key: string) => string} t
 * @returns {ReactNode}
 */
export const getCurrentStatusElement = (
    isReaded: number,
    lastFromSupport: number,
    t?: (key: string) => string,
): React.ReactNode => {
    if (isReaded === 0 && lastFromSupport === 0) {
        return <FontAwesomeIcon icon={faCheck} className="text-blueGray-300" />;
    }

    if (isReaded === 1 && lastFromSupport === 0) {
        return <FontAwesomeIcon icon={faCheckDouble} className="text-blueGray-300" />;
    }

    if (lastFromSupport === 1 && isReaded === 0 && t !== undefined) {
        return (
            <div className="flex items-center justify-end font-medium text-p2 text-blueGray-500">
                {t('New message')} <div className="w-1 h-1 ml-2 bg-red-400 rounded-full" />
            </div>
        );
    }

    return null;
};
